import { firebaseConfig } from './firebaseConfig';
import { initializeApp } from 'firebase/app';
export default initializeApp(firebaseConfig);
